import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { Amplify } from "aws-amplify";
import { getCurrentUser } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import CssBaseline from "@material-ui/core/CssBaseline";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { AWS_MOBILE } from "../client-config";
import Landing from "./Landing";
import Authentication from "./Authentication/Authentication";
import theme from "../assets/style/theme";

Amplify.configure({
  Auth: {
    Cognito: {
      region: AWS_MOBILE.region,
      userPoolId: AWS_MOBILE.userPoolId,
      userPoolClientId: AWS_MOBILE.userPoolWebClientId,
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.authListener = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "signedOut") {
        this.setState({ signedIn: false });
      }
    });

    getCurrentUser()
      .then(() => {
        this.setState({
          signedIn: true,
        });
      })
      .catch(() => {
        this.setState({
          signedIn: false,
        });
      });
  }

  componentWillUnmount() {
    if (this.authListener) {
      this.authListener();
    }
  }

  handleAuthStateChange = (state) => {
    if (state === "signedIn") {
      this.setState({
        signedIn: true,
      });
    } else if (state === "signIn") {
      this.setState({
        signedIn: false,
      });
    }
  };

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <DndProvider backend={HTML5Backend}>
          <CssBaseline />
          {this.state.signedIn ? (
            <Landing />
          ) : (
            <Authentication handleAuthChange={this.handleAuthStateChange} />
          )}
        </DndProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;
